module.exports = __webpack_public_path__ + "static/media/charity-water-logo.64c27e55.png";